import '../node_modules/bootstrap/js/affix';
import '../node_modules/bootstrap/js/alert';
import '../node_modules/bootstrap/js/button';
import '../node_modules/bootstrap/js/carousel';
import '../node_modules/bootstrap/js/collapse';
import '../node_modules/bootstrap/js/dropdown';
import '../node_modules/bootstrap/js/modal';
//import '../node_modules/bootstrap/js/popover';
import '../node_modules/bootstrap/js/scrollspy';
import '../node_modules/bootstrap/js/tab';
//import '../node_modules/bootstrap/js/tooltip';
import '../node_modules/bootstrap/js/transition';

import 'swiper';
import 'sticky';
import './plugins/scroll-progress';
import './plugins/share-selection';
import './plugins/anchor-displacement';
import './plugins/goto-home-bubble';
import './plugins/animated-underline';
import './plugins/collapse-bootstrap-menus';
import './plugins/arrows-display';
import './plugins/infinite-scroll';
import './plugins/molinillo';
import './plugins/fixed-column';
import './plugins/deactivate-tabs-resolution';
import './plugins/deactivate-tabs-onclick';
import './plugins/dynamic-arrow';
import './plugins/dependent-select';
import './plugins/datepicker';
import './plugins/match-bind';
import './plugins/select-redirect';
import './plugins/toggle-click';
import './plugins/button-displacement';
import './plugins/adver-unfix';
import './plugins/social-more';
import './plugins/init-swiper-on-tab';
import './plugins/select-display';
import './plugins/close-gallery';
import './plugins/social-sharer';
import './plugins/carousel';
import './plugins/dynamic-grid';
import './plugins/lazy';
import './plugins/social-buttons';
import './plugins/adver-displacement';
import './plugins/tab-bind';
import './plugins/edition-jumper';
import './plugins/newsletters-sticky-popups';



// WEBPACK FOOTER //
// ./src/bootstrap.config.js